export enum WsActionType {
  WS_CONNECTED = 'WS_CONNECTED',
  WS_DISCONNECTED = 'WS_DISCONNECTED',
  WS_MESSAGE = 'WS_MESSAGE',
  WS_SEND_MESSAGE = 'WS_SEND_MESSAGE',
  WS_AUTO_RECONNECT = 'WS_AUTO_RECONNECT',
  WS_PING = 'WS_PING',
}
